"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeEmailComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const login_service_1 = require("./login.service");
//INTERNAL BITS
const user_service_1 = require("./user.service");
const notification_service_1 = require("./notification.service");
let ChangeEmailComponent = class ChangeEmailComponent {
    constructor(_user, _talk, _loginService, _router) {
        this._user = _user;
        this._talk = _talk;
        this._loginService = _loginService;
        this._router = _router;
    }
    ngOnInit() {
        this.currentEmail = this._user.get().email;
    }
    onChangeEmail() {
        if (!this.newEmail)
            return this._talk.broadcast('Please make sure to provide the new email.');
        if (!this.validateEmail(this.newEmail))
            return this._talk.broadcast(`<h1>Invalid Email Provided</h1><p>Please make sure to provide a valid email. <br> Example: user@somedomain.com</p>`);
        if (this.newEmail.toLowerCase() === this.currentEmail.toLowerCase())
            return this._talk.broadcast(`<b>${this.newEmail}</b> is already your current email. Please enter a different email.`);
        this._talk.confirm(`<h1>Confirm Email Change</h1><p>Your current email(${this.currentEmail}) will be changed to <b>${this.newEmail}</b>. After clicking Ok and successful change, you will be redirected to re-login using your new email.</p>`)
            .then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        return this.submitNewEmail(this.newEmail.toLowerCase());
                    }
                }); //Just adding catch to avoid UncaughtException error to be thrown
        }).catch(err => { });
    }
    validateEmail(email) {
        //Regex Based on RFC 2822 Standard
        const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return validEmailRegex.test(email.toLowerCase());
    }
    submitNewEmail(newEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let result = yield this._user.changeEmail(newEmail);
                if (result.status === 400) {
                    const obj = JSON.parse(result._body) || " ";
                    const message = (obj.code === "E_UNIQUE") ? 'This Email Address is already in use. Kindly use diffrent one.' : 'We had a problem changing your email address';
                    this._talk.broadcast(`${message}`);
                }
                else {
                    Promise.resolve(this._talk.broadcast(`<h1>Email Successfully Changed</h1> <p>Your new account email is now set to <i>${newEmail}</i></p>`));
                    setTimeout(() => { this._loginService.logout(); }, 3000);
                }
            }
            catch (err) {
                this._talk.broadcast('We had a problem changing your email address');
            }
        });
    }
};
exports.ChangeEmailComponent = ChangeEmailComponent;
exports.ChangeEmailComponent = ChangeEmailComponent = __decorate([
    (0, core_1.Component)({
        selector: 'change-email',
        templateUrl: 'app/change-email.component.html'
    }),
    __metadata("design:paramtypes", [user_service_1.UserService,
        notification_service_1.NotificationService,
        login_service_1.LoginService,
        router_1.Router])
], ChangeEmailComponent);
//# sourceMappingURL=change-email.component.js.map